import plugin from './plugin';
import GlobalLoader_ from './GlobalLoader';

export const GlobalLoader = GlobalLoader_;
export default plugin;
